import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import socioSelector from "../store/socio.selectors";
import socioActions from "../store/socio.actions";
import autoBind from "react-autobind";
import StaticDataGrid from "@common/components/grid/staticGrid.component";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import * as messages from "@/modules/common/app/helpers/common.messages";
import decaSelector from "@/modules/deca/store/deca.selectors.js";
import solicitacaoSelector from "../../solicitacao/store/solicitacao.selectors";
class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const columns = [
      {
        fieldName: "CPF/CNPJ",
        dataName: "CpfCnpj",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Nome",
        dataName: "Nome",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Data Entrada",
        dataName: "DataEntrada",
        show: true,
        type: "date",
        removeFilter: true
      },
      {
        fieldName: "RG/IE",
        dataName: "RgIe",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Endereço",
        dataName: "EnderecoSocioGrid",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Telefone",
        dataName: "Telefone",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Email",
        dataName: "Email",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Principal",
        dataName: "Principal",
        show: true,
        array: typeArray.tipoSimNaoInt,
        type: "lista",
        arrayType: "text",
        removeFilter: true
      }
    ];

    const actions = [
      {
        title: "Tornar principal",
        icon: "fas fa-check",
        onClick: async dataItem => {
          const { socioActions } = this.props;
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3") {
            _showError(
              "Este registro não pode ser modificado durante o processo de Encerramento."
            );
            return;
          }

          socioActions.setSagaPrincipal(dataItem.IdIdentificador);
        }
      },
      {
        type: "edit",
        onClick: async dataItem => {
          const { socioActions } = this.props;
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3") {
            _showError(
              "Este registro não pode ser modificado durante o processo de Encerramento."
            );
            return;
          }
          socioActions.setPrefix("E");
          socioActions.setSagaSocio(dataItem);
          socioActions.openModalSocio();
        }
      },
      {
        type: "delete",
        onClick: async dataItem => {
          const { socioActions } = this.props;
          const {
            TipoSolicitacao,
            SituacaoSolicitacao
          } = this.props.solicitacaoSelector.solicitacao;
          if (TipoSolicitacao == "3") {
            _showError(
              "Este registro não pode ser modificado durante o processo de Encerramento."
            );
            return;
          }
          const result = await _alert.confirm(
            messages.CONFIRMA_DELETE,
            "Remover Registro Selecionado"
          );
          if (result) {
            socioActions.deleteSagaSocio(dataItem);
          }
        }
      }
    ];

    const order = [{ fieldName: "CpfCnpj", dataName: "CPF/CNPJ", order: "A" }];

    const options = {
      filterVersion: 3,
      noStorage: true,
      webStorage: "Mobiliario.CadastroEletronico.DecaSolicitacao.Socio",
      backRoute: props.backRoute || undefined,
      applySearchOnLoad: true,
      isNotCheckable: true
    };

    const toolbar = {
      tools: {
        limpar: false
      }
    };

    this.config = {
      columns,
      order,
      actions,
      options,
      toolbar
    };

    this.configView = {
      ...this.config,
      actions: [
        {
          type: "view",
          onClick: async dataItem => {
            const { socioActions } = this.props;
            socioActions.setPrefix("V");
            socioActions.setSagaSocio(dataItem);
          }
        }
      ]
    };
  }

  render() {
    const { socioSelector, disableAll } = this.props;
    const { listaSocio } = socioSelector.socio;

    return (
      <Fragment>
        {/* config da grid bugado por isso precisou dessa condição */}
        {disableAll && (
          <StaticDataGrid {...this.configView} itens={listaSocio.asMutable()} />
        )}
        {!disableAll && (
          <StaticDataGrid {...this.config} itens={listaSocio.asMutable()} />
        )}
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    socioActions
  },
  selectors: {
    socioSelector,
    solicitacaoSelector,
    decaSelector
  }
})(Container);
